export const dropdownWrapperTrigger: ('click' | 'hover' | 'contextMenu')[] = ['click'];
